import { render } from "./CreateMonster.vue?vue&type=template&id=4a17fb8a"
import script from "./CreateMonster.vue?vue&type=script&lang=js"
export * from "./CreateMonster.vue?vue&type=script&lang=js"
script.render = render

export default script